"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __importDefault(require("../utils"));
var Filter = /** @class */ (function () {
    function Filter(query, columnName) {
        this._query = query;
        // Update this to double quotes once the service layer regex is updated with correct syntax parsing
        this._columnName = "'".concat(columnName, "'");
        this._expressionParts = [];
        // verbose notation
        this.lessThan = this.lt;
        this.lessThanOrEqual = this.lte;
        this.greaterThan = this.gt;
        this.greaterThanOrEqual = this.gte;
    }
    Filter.prototype.lt = function (value) {
        this._expressionParts = [this._columnName, ' < ', utils_1.default.quote(value)];
        return this._query;
    };
    Filter.prototype.lte = function (value) {
        this._expressionParts = [this._columnName, ' <= ', utils_1.default.quote(value)];
        return this._query;
    };
    Filter.prototype.gt = function (value) {
        this._expressionParts = [this._columnName, ' > ', utils_1.default.quote(value)];
        return this._query;
    };
    Filter.prototype.gte = function (value) {
        this._expressionParts = [this._columnName, ' >= ', utils_1.default.quote(value)];
        return this._query;
    };
    Filter.prototype.isNull = function () {
        this._expressionParts = [this._columnName, ' is null'];
        return this._query;
    };
    Filter.prototype.isNotNull = function () {
        this._expressionParts = [this._columnName, ' !is null'];
        return this._query;
    };
    Filter.prototype.equals = function (value) {
        this._expressionParts = [this._columnName, ' == ', utils_1.default.quote(value)];
        return this._query;
    };
    Filter.prototype.notEquals = function (value) {
        this._expressionParts = [this._columnName, ' != ', utils_1.default.quote(value)];
        return this._query;
    };
    Filter.prototype.between = function (start, end) {
        this._expressionParts = [
            this._columnName,
            ' >= ',
            utils_1.default.quote(start),
            ', ',
            this._columnName,
            ' <= ',
            utils_1.default.quote(end),
        ];
        return this._query;
    };
    Filter.prototype.like = function (value) {
        console.warn('[Query]: using `like` is the same as using `contains`');
        return this.contains(value);
    };
    Filter.prototype.notLike = function (value) {
        console.warn('[Query]: using `notLike` is the same as using `notContains`');
        return this.notContains(value);
    };
    Filter.prototype.contains = function (value) {
        this._expressionParts = [
            this._columnName,
            ' contains ',
            utils_1.default.quote(value),
        ];
        return this._query;
    };
    Filter.prototype.notContains = function (value) {
        this._expressionParts = [
            this._columnName,
            ' !contains ',
            utils_1.default.quote(value),
        ];
        return this._query;
    };
    Filter.prototype.in = function (values) {
        this._expressionParts = [
            this._columnName,
            ' in ',
            '[',
            utils_1.default.quote(values).join(','),
            ']',
        ];
        return this._query;
    };
    Filter.prototype.notIn = function (values) {
        this._expressionParts = [
            this._columnName,
            ' !in ',
            '[',
            utils_1.default.quote(values).join(','),
            ']',
        ];
        return this._query;
    };
    Filter.prototype.query = function () {
        return this._expressionParts.map(encodeURIComponent).join('');
    };
    return Filter;
}());
exports.default = Filter;
